export default __webpack_public_path__ + "static/boba-bda8d8360de06e9d22e1bb64dbc3cb0a.jpg";